import { useState } from 'react';
import { glyph } from '@/lib/symbols';

interface SymbolCardProps {
    name: string;
    code: string;
}

export default function SymbolCard({ name, code }: SymbolCardProps) {
    const [copied, setCopied] = useState(false);
    const char = glyph(code);

    const handleCopy = () => {
        navigator.clipboard.writeText(char);
        setCopied(true);
        setTimeout(() => setCopied(false), 1200);
    };

    return (
        <div
            onClick={handleCopy}
            className={`relative flex min-w-0 cursor-pointer flex-col items-center justify-center rounded-lg border-[0.5px] bg-surface px-1.5 pb-2 pt-2.5 transition-colors ${
                copied ? 'border-teal' : 'border-line hover:border-line-strong'
            }`}
        >
            {copied && (
                <span className="absolute right-1 top-1 rounded-[4px] bg-teal-soft px-1 py-px text-[9px] font-medium uppercase text-teal-ink">
                    Copied
                </span>
            )}
            <div className="mb-1 text-2xl leading-tight text-ink">{char}</div>
            <div className="w-full truncate text-center text-[11px] text-muted">{name}</div>
            <div className="mt-0.5 font-mono text-[10px] text-hint">{code}</div>
        </div>
    );
}
